exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".order-header[data-v-7c14c572]{top:6.5rem}.common-header[data-v-7c14c572]{padding-top:0!important}.common-header[data-v-7c14c572] .mint-header-title{margin-bottom:15px!important}", ""]);

// exports
